import React, { useState } from 'react';
import { Box, Typography, Button, CircularProgress, Paper, Alert, Link } from '@mui/material'; // Aggiunto Alert
import { auth, db } from '../firebase';
import { doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const TermsAndConditions = () => {
  const navigate = useNavigate();
  const [isAccepting, setIsAccepting] = useState(false);
  const [error, setError] = useState(null); // Stato per l'errore

  const handleAccept = async () => {
    try {
      setIsAccepting(true);
      setError(null); // Resetta eventuali errori precedenti
      const user = auth.currentUser;
      if (!user) {
        throw new Error('Utente non autenticato');
      }

      await updateDoc(doc(db, 'users', user.uid), {
        acceptedTerms: true,
        acceptedAt: new Date(),
      });

      navigate('/dashboard');
    } catch (error) {
      console.error('Errore durante l\'accettazione delle condizioni:', error);
      setError('Si è verificato un errore durante l\'accettazione. Riprova.'); // Messaggio di errore specifico
      setIsAccepting(false);
    }
  };

  return (
    <Box sx={{ padding: 4, maxWidth: 800, margin: 'auto', textAlign: 'center' }}>
      <Paper sx={{ padding: 4, boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}> {/* Ombra leggera */}
        <Typography variant="h4" gutterBottom component="h1">
          Termini e Condizioni d'Uso
        </Typography>
        <Box
          sx={{
            maxHeight: '75vh', // Aumentato maxHeight
            overflowY: 'auto',
            textAlign: 'left',
            paddingRight: 2,
            marginBottom: 2,
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '16px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)' // Ombra leggera
          }}
        >
          <Typography variant="h6" gutterBottom component="h2">
            1. Introduzione
          </Typography>
          <Typography variant="body1" paragraph>
            Benvenuto in QuantoSpendo, un'applicazione per la gestione delle spese personali. Questi Termini e Condizioni d'Uso regolano l'accesso e l'utilizzo dell'applicazione. Utilizzando QuantoSpendo, accetti di rispettare e essere vincolato da questi termini. Se non sei d'accordo con qualche parte di questi termini, ti invitiamo a non utilizzare l'applicazione.
          </Typography>

          <Typography variant="h6" gutterBottom component="h2">
            2. Raccolta dei Dati
          </Typography>
          <Typography variant="body1" paragraph>
            <b>Dati Personali:</b> Quando ti registri a QuantoSpendo, raccogliamo il tuo indirizzo email.  Questa informazione è necessaria per creare e gestire il tuo account, permetterti di accedere all'applicazione e comunicare con te in caso di problemi o per fornirti assistenza.
          </Typography>
          <Typography variant="body1" paragraph>
            <b>Dati di Utilizzo:</b> Utilizziamo Google Analytics per monitorare e analizzare l'utilizzo dell'applicazione.  Questo include informazioni sul tuo dispositivo (tipo, sistema operativo, identificatori univoci), informazioni sull'utilizzo dell'app (pagine visitate, funzionalità utilizzate, tempo trascorso) e dati di eventi (azioni specifiche eseguite).  Questi dati sono raccolti in forma aggregata e anonima e non sono collegati al tuo indirizzo email. Google Analytics anonimizza il tuo indirizzo IP.
          </Typography>
          <Typography variant="body1" paragraph>
            <b>Cookie:</b> Utilizziamo cookie tecnici strettamente necessari per il funzionamento dell'applicazione (ad esempio, per mantenere la tua sessione attiva) e cookie gestiti da iubenda per la gestione del consenso.  Puoi trovare maggiori informazioni sui cookie nella nostra <Link href="https://www.iubenda.com/privacy-policy/93756875/cookie-policy" className="iubenda-white iubenda-noiframe iubenda-embed" title="Cookie Policy">Cookie Policy</Link>.
          </Typography>
          <Typography variant="body1" paragraph>
            <b>Dati Inseriti Manualmente:</b> I dati relativi alle tue spese che inserisci manualmente in QuantoSpendo sono archiviati nel tuo account e sono utilizzati esclusivamente per fornirti il servizio di gestione delle spese.
          </Typography>
            <Typography variant="body1" paragraph>
            <b>Base Giuridica:</b> Trattiamo i tuoi dati personali sulla base del tuo consenso (per Google Analytics) e per l'esecuzione del contratto (per la fornitura del servizio).
            </Typography>

          <Typography variant="h6" gutterBottom component="h2">
            3. Uso dei Dati
          </Typography>
          <Typography variant="body1" paragraph>
            Utilizziamo i dati raccolti per fornire e migliorare il servizio QuantoSpendo, per personalizzare la tua esperienza, per identificare e risolvere problemi tecnici, per sviluppare nuove funzionalità e per comunicare con te in merito al tuo account.  Non vendiamo né affittiamo i tuoi dati personali a terze parti.
          </Typography>

          <Typography variant="h6" gutterBottom component="h2">
            4. Protezione dei Dati
          </Typography>
          <Typography variant="body1" paragraph>
            Implementiamo misure di sicurezza tecniche e organizzative adeguate per proteggere i tuoi dati personali, tra cui la crittografia dei dati in transito e a riposo e l'accesso limitato ai dati. Tuttavia, nessun sistema di sicurezza è impenetrabile e non possiamo garantire la sicurezza assoluta dei tuoi dati.
          </Typography>

          <Typography variant="h6" gutterBottom component="h2">
            5. Diritti dell'Utente
          </Typography>
          <Typography variant="body1" paragraph>
            Ai sensi del Regolamento Generale sulla Protezione dei Dati (GDPR), hai i seguenti diritti:
          </Typography>
            <ul>
                <li><b>Diritto di accesso:</b> Hai il diritto di sapere quali dati personali trattiamo e di ottenerne una copia.</li>
                <li><b>Diritto di rettifica:</b> Hai il diritto di chiedere la correzione di dati inesatti o incompleti.
                </li>
                <li><b>Diritto alla cancellazione ("diritto all'oblio"):</b> Hai il diritto di chiedere la cancellazione dei tuoi dati personali in determinate circostanze.</li>
                <li><b>Diritto di limitazione di trattamento:</b> puoi chiederci di limitare l'elaborazione dei tuoi dati</li>
                <li><b>Diritto alla portabilità dei dati:</b> Hai il diritto di ricevere i tuoi dati in un formato strutturato, di uso comune e leggibile da dispositivo automatico, e di trasmetterli a un altro titolare del trattamento, se tecnicamente fattibile.</li>
                <li><b>Diritto di opposizione:</b> Hai il diritto di opporti al trattamento dei tuoi dati personali per finalità di marketing diretto o per altri motivi legittimi.</li>
            </ul>
          <Typography variant="body1" paragraph>
            Per esercitare i tuoi diritti, puoi inviare una richiesta a <Link href="mailto:info@quantospendo.com">info@quantospendo.com</Link>.
          </Typography>


          <Typography variant="h6" gutterBottom component="h2">
            6. Modifiche ai Termini
          </Typography>
          <Typography variant="body1" paragraph>
            Ci riserviamo il diritto di modificare questi Termini e Condizioni in qualsiasi momento. Ti informeremo di eventuali cambiamenti pubblicando i nuovi termini sull'applicazione. Continuando a utilizzare QuantoSpendo dopo tali modifiche, accetti i nuovi termini.
          </Typography>

          <Typography variant="h6" gutterBottom component="h2">
            7. Contatti
          </Typography>
          <Typography variant="body1" paragraph>
            Per qualsiasi domanda o dubbio riguardo a questi Termini e Condizioni, puoi contattarci all'indirizzo email: <Link href="mailto:info@quantospendo.com">info@quantospendo.com</Link>.
          </Typography>

          <Typography variant="h6" gutterBottom component="h2">
            8. Legge Applicabile
          </Typography>
          <Typography variant="body1" paragraph>
            Questi Termini e Condizioni sono regolati e interpretati secondo le leggi italiane e al Regolamento Generale sulla Protezione dei Dati (GDPR). Qualsiasi controversia derivante dall'uso dell'applicazione sarà soggetta alla giurisdizione esclusiva dei tribunali italiani.
          </Typography>
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>} {/* Visualizza l'errore */}

        <Button
          variant="contained"
          onClick={handleAccept}
          disabled={isAccepting}
          sx={{ marginTop: 2 }}
        >
          {isAccepting ? <CircularProgress size={24} color="inherit" /> : 'Accetto'}
        </Button>
      </Paper>
    </Box>
  );
};

export default TermsAndConditions;